import mapboxgl from "mapbox-gl";
import {gsap} from "gsap";
import '@lottiefiles/lottie-player';

export default {
    data() {
        return {
            tipwalk: {
                screen: null,
                activeQuestion: null,
                answers: [],
                screenAnimationTime: 0.5,
                correctPlayer: null,
                nextTriggered: false,
                markerReadyForFlash: false
            }
        }
    },
    computed: {
        isTipwalk() {
            return this.widgetSettings.view === 'tipwalk';
        },
        closePointTxt() {
            let txt = 'Fortsätt';
            // Check if all questions are answered
            if (this.tipwalk.answers.length === this.settings.tipwalk.positions.length) {
                txt = 'Stäng';
            }
            return txt;
        },
        tipwalkShowCloseAnswer() {
            return this.tipwalk.answers[this.tipwalk.activeQuestion];
        }
    },
    methods: {
        initTipWalk() {

            if(!this.mobile && !this.isDev){
                this.overlayMessage.active = true;
                this.overlayMessage.msg = 'Använd din telefon för att genomföra tipspromenaden.';
                return;
            }

            this.tipwalkScreen('start');
        },
        startTipWalk() {
            let app = this;

            this.requestUserLocation();
            this.createTipWalkMarkers();
            this.tipwalk.screen = null;
            this.toggle3d();
            this.showNextPoint();

            this.tipwalk.correctPlayer = document.querySelector('lottie-player.correct');

            this.log('MOBILE? ' + this.mobile);


            if(this.mobile){
                app.mapbox.map.on('touchstart', () => {
                    app.mapClick();
                });
            } else {
                app.mapbox.map.on('click', () => {
                    app.mapClick();
                });
            }

        },
        tipwalkScreen(screen) {
            let app = this;
            let container = document.querySelector('.screen.' + screen);
            // Do animation and close if any is active

            if (this.tipwalk.screen) {
                gsap.to(container, {yPercent: 20, opacity: 0, duration: 0});
            }

            this.tipwalk.screen = screen;

            gsap.fromTo(container, {opacity: 1, yPercent: 20, scaleX: 0.8}, {
                yPercent: 0,
                scaleX: 1,
                opacity: 1,
                duration: app.tipwalk.screenAnimationTime,
                ease: 'Expo.easeOut'
            });
        },
        unlockPoint(index) {

            // Already open?
            if(this.settings.tipwalk.positions[index].question.unlocked) return;

            this.settings.tipwalk.positions[index].question.unlocked = true;

            let marker = document.querySelector('.marker-tipwalk.tipwalk-' + index);

            marker.classList.remove('state-1');
            marker.classList.remove('state-2');
            marker.classList.add('state-3');

            // Do a bounce on bubble
            let bubble = marker.querySelector('.bubble');
            gsap.fromTo(bubble, {opacity: 0, yPercent: 100}, {
                yPercent: 0,
                opacity: 1,
                delay: 1.75,
                duration: 1.75,
                ease: 'elastic.out(1, 0.3)'
            });

            this.log(marker.classList);

        },
        openPoint(index) {
            this.tipwalk.correctPlayer.stop();
            this.tipwalkScreen('point');
            this.tipwalk.activeQuestion = index;

        },
        answerTipWalk(q, ans, correct) {
            this.tipwalk.answers[q] = {
                ans: ans,
                correct: correct
            };

            if (correct) {
                this.tipwalk.correctPlayer.stop();
                this.tipwalk.correctPlayer.play();
            }

            // Set active state to marker
            let marker = document.querySelector('.marker-tipwalk.tipwalk-' + q);
            marker.classList.add('answered');



            // activate next point
            this.showNextPoint();

        },
        showNextPoint() {
            let next = this.tipwalk.answers.length;
            let app = this;
            this.tipwalk.nextTriggered = false;

            // If in bad accuracy, zoom map to show next
            if(this.isBadAccuracy) {
                this.zoomBounds(false, true);
            }


            let marker = document.querySelector('.marker-tipwalk.tipwalk-' + next);
            marker.classList.add('show');
        },
        showNextPointBubble() {

            if(this.tipwalk.nextTriggered) return;

            let next = this.tipwalk.answers.length;
            gsap.fromTo('.marker-tipwalk.tipwalk-' + next + ' .bubble', {opacity: 0, yPercent: 100}, {
                yPercent: 0,
                opacity: 1,
                delay: 2,
                duration: 1.2,
                ease: 'elastic.out(1, 0.3)'
            });

            this.tipwalk.nextTriggered = true;

            setTimeout(() => {
                this.tipwalk.markerReadyForFlash = true;
            }, 3200);

        },
        createTipWalkMarkers() {
            let app = this;

            this.settings.tipwalk.positions.forEach(function (pos, i) {

                // Make sure we have coordinates
                if(!pos.question.position.lng || !pos.question.position.lat) return;

                // create a HTML element for each feature
                let el = document.createElement('div');
                el.className = 'marker-tipwalk';
                el.className += ' tipwalk-' + i;
                el.innerHTML += '<img class="unanswered" src="' + app.settings.tipwalk.marker_img + '">';
                el.innerHTML += '<img class="answered" src="' + app.settings.tipwalk.marker_img_done + '">';
                el.innerHTML += '<div class="bubble"><span class="msg1">Kom och lek!</span><span class="msg2">Kom närmare!</span><span class="msg3">Kan du svaret?</span></div>';
                el.innerHTML += '<div class="flash"></div>';
                el.innerHTML += '<div class="circle"></div>';

                // make a marker for each feature and  add to the map
                new mapboxgl.Marker(el).setLngLat([parseFloat(pos.question.position.lng), parseFloat(pos.question.position.lat)]).addTo(app.mapbox.map);

                // Attach click event to marker
                el.addEventListener('click', function (el) {

                    console.log('Marker clicked');

                    // Only allow click when unlocked,
                    if(!app.isBadAccuracy && !app.settings.tipwalk.positions[i].question.unlocked) return;

                    console.log('Marker clicked 2');

                    app.openPoint(i);
                    return false;
                });


            });


        },
        closePoint() {
            let app = this;

            this.tipwalk.screen = null;
            this.tipwalk.activeQuestion = null;

            // Check if all questions are answered
            if (this.tipwalk.answers.length === this.settings.tipwalk.positions.length) {
                setTimeout(() => app.tipwalkScreen('end'), 300);

                // Stop geolocation
                this.stopLocationWatch();
            }


        },
        checkNearbyTipwalk(crd) {

            if(!this.isTipwalk) return;

            let meters, distance;
            let app = this;

            this.settings.tipwalk.positions.forEach(function (pos, i) {

                // ignore if already answered
                if (app.tipwalk.answers[i]) return;

                // Ignore if not the right one in order
                if (app.tipwalk.answers.length !== i) return;

                // Get distance
                distance = app.getDistance("userPos", crd.latitude, crd.longitude, "checkpoint", pos.question.position.lat, pos.question.position.lng);
                meters = parseFloat(distance.distance_kilometres) * 1000;

                // If close enough, show marker
                if (meters <= app.acceptedAccuracy) {
                    app.log('UNLOCK ' + i);
                    app.unlockPoint(i);
                }

            });

            this.showNextPointBubble();
        },
        mapClick() {
            // Trigger some stuff on markers when clicking on screen
            let app = this;
            console.log('Map click');

            let index = app.tipwalk.answers.length;

            if(this.settings.tipwalk.positions[index].question.unlocked) return;

            let marker = document.querySelector('.marker-tipwalk.tipwalk-' + index);

            marker.classList.remove('state-1');
            marker.classList.remove('state-2');
            marker.classList.remove('state-3');

            marker.classList.add('state-2');

            if(!this.isBadAccuracy && !this.tipwalk.markerReadyForFlash) return;

            marker.classList.add('trigger-flash');
            setTimeout(function(){
                marker.classList.remove('trigger-flash');
            }, 300);

        },
        doTipwalkDev() {
            let app = this;

            if (!this.isDev) return;

            app.mapbox.map.on('click', function (e) {

                //JSON.stringify(e.lngLat.wrap());
                let coors = e.lngLat.wrap();
                let pos = {
                    coords: {
                        longitude: coors.lng,
                        latitude: coors.lat,
                        accuracy: 10,
                        altitude: null,
                        altitudeAccuracy: null,
                        heading: null,
                        speed: null,
                    },
                    timestamp: Date.now()
                }

                app.locationUpdate(pos);

            });
        },

    },
    mounted() {
      // this.tipwalkScreen('start');
    }
}

